import type { ScreenId } from '../types/demo'

export interface StoryStep {
  id: string
  label: string
  screens: ScreenId[]
  entry: ScreenId
}

export const storySteps: StoryStep[] = [
  { id: 'sixbefore', label: 'SixBefore', screens: ['prequelEntry', 'prequelStory', 'prequelQuiet'], entry: 'prequelEntry' },
  { id: 'bridge', label: 'Time-Bridge', screens: ['bridge'], entry: 'bridge' },
  { id: 'arrival', label: 'Savanna City', screens: ['arrival'], entry: 'arrival' },
  { id: 'clues', label: 'Six clues', screens: ['clues'], entry: 'clues' },
  { id: 'sorting', label: 'Signal or Static', screens: ['sorting'], entry: 'sorting' },
  { id: 'action', label: 'Next step', screens: ['action'], entry: 'action' },
  { id: 'witness', label: 'Giraffe', screens: ['witness'], entry: 'witness' },
  { id: 'ripple', label: 'Ripple Map', screens: ['ripple'], entry: 'ripple' },
  { id: 'signalCheck', label: 'Signal Check', screens: ['signalCheck'], entry: 'signalCheck' },
  { id: 'wateringMap', label: 'Watering Hole Map', screens: ['wateringMap'], entry: 'wateringMap' },
  { id: 'echo', label: 'Echo', screens: ['echo'], entry: 'echo' },
  { id: 'finish', label: 'Two Sounds', screens: ['finish'], entry: 'finish' },
]

export const fieldGuideItems = [
  { id: 'purrAnchor', title: 'Purr Anchor' },
  { id: 'seed', title: 'Time-Bridge seed' },
  { id: 'clues', title: 'Viewed clues' },
  { id: 'signalCheck', title: 'Signal / Static Check' },
  { id: 'wateringMap', title: 'Safe Watering Hole Map' },
  { id: 'echo', title: 'Echo Fragment' },
] as const
